import script from "./AppSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSelect.vue?vue&type=script&setup=true&lang=js"

import "./AppSelect.vue?vue&type=style&index=0&id=e1c143c0&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1c143c0"]])

export default __exports__